import * as constants from "../../constants/common";

export const participationTypes = ($locale) => [
    {
        value: constants.TYPE_ONLINE,
        label: $locale.get('participationType.online'),
    },
    {
        value: constants.TYPE_OFFLINE,
        label: $locale.get('participationType.offline'),
    },
];

export const emailRequestErrorMessage = ($locale) => {

};
